import {useQuery} from "react-query";
import ngage from "../../services/ngage";
import {QuizFilters} from "../../services/ngage/quizzes";

export default function useGetQuizzes(
  criteria: QuizFilters = {},
  keepPreviousData?: boolean,
  enabled?: boolean
) {
  return useQuery(
    ['quizzes.all', criteria],
    () => ngage.quizzes.filtered(criteria),
    {enabled, keepPreviousData}
  );
}